import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppConfigService } from 'src/app/config/appconfig.service';
import { PaymentMethodModel } from 'src/app/models/payment-method.model';
import { UserDetails } from 'src/app/models/user-details.model';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-view-payment-details',
  templateUrl: './view-payment-details.component.html',
  styleUrls: ['./view-payment-details.component.scss']
})
export class ViewPaymentDetailsComponent {

  payment: PaymentMethodModel;
  acDetails: any;
  currentDate: Date;
  userInfo: UserDetails;
  paymentAmount: number;
  receiptId: string;
  isGracePayment: boolean = false;

  constructor(private router: Router, private storageService:StorageService, private config: AppConfigService) {
    this.isGracePayment = this.config.getIsGracePayment();
    this.currentDate= new Date();
    let userInfo = this.storageService.getUserInfo();
    if(userInfo == null){
      this.router.navigateByUrl('/policy-search');
    } else{
      this.userInfo = userInfo;
    }
    let paymentAmount = this.storageService.getPaymentAmount();
    if(paymentAmount == null){
      this.router.navigateByUrl('/payment');
    } else{
      this.paymentAmount = paymentAmount;
    }

    let receiptId = this.storageService.getReceiptId();
    if(receiptId == null){
      this.router.navigateByUrl('/home');
    } else{
      this.receiptId = receiptId;
    }
    
    let paymentMethodData = this.storageService.getSelectedPaymentMethod();
    if(paymentMethodData == null){
       this.router.navigateByUrl('/payment-method');
    } else{
      let paymentMethod = paymentMethodData.paymentMethod;
      let bankDetails, creditCard = null;
      this.payment={
        paymentMethod,
        creditCard,
        bankDetails
      }
      if(paymentMethod =='Bank Account'){
        this.payment.bankDetails=paymentMethodData.paymentToken.paymentTxnDetails.electronicFunds.electronicFundsTransfer;
      } else if(paymentMethod =='Credit Card'){
        this.payment.creditCard = paymentMethodData.additionalDetails.additionalCardInfo;
      }
    }

  }

}
